import useSWR from 'swr';

export interface CryptoRelatedNewsItem {
  news_id: string;
  title: string;
  summary: string;
  source: string;
  source_icon_url: string;
  source_url?: string;
  publish_time: string;
  importance_level: number;
  is_breaking: boolean;
  is_hot: boolean;
  recommended_questions?: string[];
}

export interface CryptoRelatedNewsResponse {
  symbol: string;
  news: CryptoRelatedNewsItem[];
  limit: number;
  offset: number;
}

export function useCryptoRelatedNews(symbol: string) {
  return useSWR<CryptoRelatedNewsResponse>(
    symbol ? `api:/market/crypto/${symbol.toLowerCase()}/relate-news` : null,
  );
}
